import { useState } from "react";

function useMenuState(initialState) {
  const [isOpen, setIsOpen] = useState(initialState);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return [isOpen, handleOpen, handleClose];
}

export default useMenuState;

export function useMenuState2(initialState) {
  const [isOpen2, setIsOpen2] = useState(initialState);

  const handleOpen2 = () => {
    setIsOpen2(true);
  };

  const handleClose2 = () => {
    setIsOpen2(false);
  };

  return [isOpen2, handleOpen2, handleClose2];
}
